// ====================================================
// Handles adding/removing products to favourites
(function Favourites() {

  // Cache relevant HTML elements
  const buttons = document.querySelectorAll('.favourite-button');

  // Set correct heart icon if item is in favourites or not
  function updateFavouriteDisplay() {
    const itemId = 'favourite-' + this.dataset.id;
    const isItemSaved = localStorage.getItem(itemId) !== null;

    this.classList.toggle('favourite-ico-set', isItemSaved);
  }

  // Play click animation for heart icon
  function playFavouriteIconAnimation() {
    this.classList.add('favourite-ico-click');
    setTimeout(() => {
      this.classList.remove('favourite-ico-click');
    }, 200);
  }

  // Toggle favourite state and update icon display
  function onFavouriteIconClick() {
    const itemId = 'favourite-' + this.dataset.id;
    const isItemSaved = localStorage.getItem(itemId) !== null;

    if (isItemSaved) {
      localStorage.removeItem(itemId);
    } else {
      localStorage.setItem(itemId, 'set');
    }

    updateFavouriteDisplay.call(this.iconContainer);
    this.icons.forEach(icon => playFavouriteIconAnimation.call(icon));
  }

  // Setup
  buttons.forEach(button => {
    button.iconContainer = button.querySelector('.favourite-ico-container');
    button.icons = button.querySelectorAll('.favourite-ico');
    button.addEventListener('click', onFavouriteIconClick);

    // Update initial display
    updateFavouriteDisplay.call(button.iconContainer);
  });

})();

// ====================================================
// Split main navigation links into two columns
(function NavLinkSplit() {

  // Creates main navigation link column
  function createColumn() {
    const column = document.createElement('div');
    column.classList.add('nav-childlink-section');

    return column;
  }

  const linkParents = document.querySelectorAll('.main-menu-dropdown-parent > ul');

  // Split main navigation links into two columns
  linkParents.forEach(linkParent => {
    const children = linkParent.querySelectorAll('.child');

    // Skip splitting if there are too few child elements
    if (children.length < 4)
      return;

    // Create two column to relocate child elements
    const column1 = createColumn();
    const column2 = createColumn();

    // Get amount of children to place in first column
    // ~~(variable) === Math.floor(variable)
    let breakOffPoint = ~~(children.length / 2);
    if (children.length % 2 !== 0) {
      breakOffPoint = (~~(children.length / 2)) + 1;
    }

    // Sort children into the two columns
    for (let i = 0; i < children.length; i++) {
      if (i < breakOffPoint) {
        column1.appendChild(children[i]);
      } else {
        column2.appendChild(children[i]);
      }
    }

    // Append the columns to main parent
    linkParent.appendChild(column1);
    linkParent.appendChild(column2);
  });

})();

// ====================================================
// Makes cart link only display on mobile
(function UpdateCartLinkClass() {

  const links = document.querySelectorAll('.main-menu li');
  links.forEach(link => {
    const anchor = link.querySelector('a');
    if (anchor.innerHTML.toLowerCase() === 'cart') {
      link.classList.add('main-menu-link-onlydesktop');
    }
  });

})();

// ====================================================
// Sets up the highlight three section
(function HighlightThree() {
   (function AdjustItemWidths() {
      function adjust() {
         const containers = document.querySelectorAll('.three_section-container-main');
         containers.forEach(container => {
            const rows = [[]];
            let current_row = 0;

            const offsets = [];
            let current_offset = 0;

            const items = container.querySelectorAll('.three_section-container');
            items.forEach(item => {
               const offset = Math.floor(item.getBoundingClientRect().top);

               if (offsets.length === 0)
                  offsets.push(offset);

               if (Math.abs(offsets[current_offset] - offset) <= 50) {
                  rows[current_row].push(item);
               } else {
                  rows.push([]);
                  current_row++;

                  offsets.push(offset);
                  current_offset++;
                  rows[current_row].push(item);
               }
            });

            rows.forEach(row => {
               if (row.length === 2) {
                  row.forEach(item => item.classList.add('w50'));
               } else if (row.length === 1) {
                  row[0].classList.add('w100');
               }
            });
         });
      }

      window.addEventListener('resize', adjust);
      adjust();
   })();

  (function AddToCart() {
    function on_button_click(event) {
        event.preventDefault();

        if (this.dataset.soldOut)
          return false;

        Shopify.getCart(cart => ajaxifyShopify.buildCart(cart));
        Shopify.addItem(this.dataset.id, 1, function() {
        Shopify.getCart(cart => ajaxifyShopify.buildCart(cart));
      });

      return false;
    }

    function on_overlay_click(event) {
      window.location = this.dataset.link;
    }

    const add_buttons = document.querySelectorAll('.three_section-view');
    add_buttons.forEach(btn => btn.addEventListener('click', on_button_click));

    const overlays = document.querySelectorAll('.three_section-image-overlay');
    overlays.forEach(overlay => overlay.addEventListener('click', on_overlay_click));

    function on_size_selector_click(event) {
      if (event)
        event.stopPropagation();

      const prev = this.parentNode.querySelector('.product_size-option.selected');
      if (prev)
        prev.classList.remove('selected');

      this.classList.add('selected');
      this.btnToCart.dataset.id = this.dataset.value;

      return false;
    }

    const button_containers = document.querySelectorAll('.three_section-button-container');
    button_containers.forEach(button_container => {
      const options_container = button_container.querySelector('.product_size-options');
      if (!options_container)
        return;

      const btn_add_to_cart = button_container.querySelector('.three_section-vieww');

      const options = options_container.querySelectorAll('.product_size-option');
      options.forEach(option => {
        option.btnToCart = btn_add_to_cart;
        option.addEventListener('click', on_size_selector_click);
      });

      on_size_selector_click.call(options[0]);
    });
  })();
})();
